
<list-controls [page]="list.currentPage" [numPages]="list.maxPages" [limit]="list.pageSize" [totalCount]="list.filteredLength" [search]="list.searchText" [searchHelp]="searchHelp" [showSearch]="showSearch" [showLimit]="showLimit" (onChange)="list.onListControlsChange($event)">
  <ng-content></ng-content>
</list-controls>